import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FateDropdown } from 'fate-editor';

/**Componente per la dropdown delle citazioni dalla Bibbia */
@Component({
  selector: 'app-bible-dropdown',
  templateUrl: '../quote-template.html',
  styleUrls: ['../editor-dropdowns.css']
})
export class BibleDropdownComponent implements FateDropdown {
  /**Input, la stringa eventualmente selezionata */
  @Input()
  public value: string;
  /**Emettitore per il valore selezionato dalla dropdown */
  @Output() public valueChange = new EventEmitter<string>();

  /**Lista dei possibili valori di citazione biblica */
  noteList = [
    {
      etichetta: 'Genesi',
      valore: 'Gen. : '
    },
    {
      etichetta: 'Esodo',
      valore: 'Es. : '
    },
    {
      etichetta: 'Levitico',
      valore: 'Lev. : '
    },
    {
      etichetta: 'Numeri',
      valore: 'Num. : '
    },
    {
      etichetta: 'Deuteronomio',
      valore: 'Deut. : '
    },
    {
      etichetta: 'Giosuè',
      valore: 'Gios. : '
    },
    {
      etichetta: 'Giudici',
      valore: 'Giud. : '
    },
    {
      etichetta: '1 Samuele',
      valore: '1 Sam. : '
    },
    {
      etichetta: '2 Samuele',
      valore: '2 Sam. : '
    },
    {
      etichetta: '1 Re',
      valore: '1 Re : '
    },
    {
      etichetta: '2 Re : ',
      valore: '2 Re : '
    },
    {
      etichetta: 'Isaia',
      valore: 'Is. : '
    },
    {
      etichetta: 'Ezechiele',
      valore: 'Ez. : '
    },
    {
      etichetta: 'Osea',
      valore: 'Os. : '
    },
    {
      etichetta: 'Gioele',
      valore: 'Gioe. : '
    },
    {
      etichetta: 'Amos',
      valore: 'Am. : '
    },
    {
      etichetta: 'Ovadià',
      valore: 'Ov. : '
    },
    {
      etichetta: 'Giona',
      valore: 'Giona : '
    },
    {
      etichetta: 'Mikhà',
      valore: 'Mi. : '
    },
    {
      etichetta: 'Nachum',
      valore: 'Na. : '
    },
    {
      etichetta: 'Chabaquq',
      valore: 'Chab. : '
    },
    {
      etichetta: 'Tzefanya',
      valore: 'Tze. : '
    },
    {
      etichetta: 'Chaggai',
      valore: 'Chag. : '
    },
    {
      etichetta: 'Zaccaria',
      valore: 'Zac. : '
    },
    {
      etichetta: 'Malachia',
      valore: 'Mal. : '
    },
    {
      etichetta: 'Salmi',
      valore: 'Sal. : '
    },
    {
      etichetta: 'Proverbi',
      valore: 'Pro. : '
    },
    {
      etichetta: 'Giobbe',
      valore: 'Giob. : '
    },
    {
      etichetta: 'Cantico dei cantici',
      valore: 'Cant. : '
    },
    {
      etichetta: 'Rut',
      valore: 'Rut : '
    },
    {
      etichetta: 'Ekhà/Lamentazioni',
      valore: 'Ekhà : '
    },
    {
      etichetta: 'Qohelet/Ecclesiaste',
      valore: 'Qo. : '
    },
    {
      etichetta: 'Ester',
      valore: 'Est. : '
    },
    {
      etichetta: 'Daniele',
      valore: 'Dan. : '
    },
    {
      etichetta: 'Ezra',
      valore: 'Ezra : '
    },
    {
      etichetta: 'Nechemia',
      valore: 'Nech. : '
    },
    {
      etichetta: '1 Cronache',
      valore: '1 Cr. : '
    },
    {
      etichetta: '2 Cronache',
      valore: '2 Cr. : '
    }
  ];

  /**Indice elemento selezionato */
  public selected = 0;

  /**
   * Metodo che gestisce l'emissione del valore selezionato
   * @param value {any} il valore selezionato
   */
  public changeValue(value) {
    this.valueChange.emit(value);
  }

  /**Metodo che gestisce la selezione del successivo */
  public selectNext() {
    this.selected++;
    if (this.selected >= this.noteList.length) {
      this.selected = this.noteList.length - 1;
    }
  };

  /**Metodo che gestisce la selezione del precedente */
  public selecPrevious() {
    this.selected--;
    if (this.selected < 0) {
      this.selected = 0;
    }
  };

  /**Metodo che conferma la selezione lanciando il metodo di cambio valore */
  public confirmSelection() {
    this.changeValue(this.noteList[this.selected]);
  };
  constructor() { }

}
